<ng-container formGroupName="foreignTaxDetails">
  <h1 class="ibk-title">Declaro que<span class="dots">:</span></h1>

  <p class="ibk-question">
    <!-- ¿Tu empresa tiene residencia fiscal o tributaria en Perú? -->
    <ng-content></ng-content>
  </p>

  <ibk-input-radio-group
    dsRxForm="radioChange"
    #taxControl="control"
    formControlName="isTaxOutsideCountry"
    name="isTaxOutsideCountry"
    class="radio-group"
  >
    <ibk-input *ngFor="let option of options; let i = index">
      <span>{{ option.label }}</span>
      <input [value]="option.value" />
    </ibk-input>
  </ibk-input-radio-group>

  <!-- <ng-template #noMark>
    Lo sentimos, la creación de esta cuenta requiere que tu empresa posea
    residencia y obligaciones fiscales y tributarias solo en Perú.
  </ng-template>

  <ibk-toast
    *ngIf="taxControl.hasValue()"
    [type]="taxControl.equals(true) ? 'INFO' : 'ERROR'">
    <ng-container *ngIf="taxControl.equals(true)">
      Al marcar “Si” declaro bajo juramento que la información proporcionada es 
      veraz, completa y actualizada, de conformidad con la Ley 26702 (Ley 
      General del Sistema Financiero) y el Decreto Supremo 256-2018-EF (Información 
      financiera que  los bancos deben comunicar a SUNAT).
    </ng-container>
    <ng-container *ngIf="taxControl.equals(false)">
      <ng-container *ngTemplateOutlet="noMark"></ng-container>
    </ng-container>
  </ibk-toast> -->
</ng-container>
